import axios from '@/plugins/axios';
import utils from '@/stores/utils';

const createState = () => ({
    scopes: [],
    scopes_loaded: false,
    scopes_loading: false,
    scopes_loading_errors: null,
    profile: null,
});

const getters = {
    // Group the flat scope list into modules -> [{ code, label }].
    // Labels (en/fr) come from the API (mcl.core.scopes), not Django i18n.
    // Relies on the API returning scopes in display order.
    scopeModules(state) {
        const modules = [];
        const moduleIndex = {};
        state.scopes.forEach((scope) => {
            if (!(scope.module_code in moduleIndex)) {
                moduleIndex[scope.module_code] = modules.length;
                modules.push({
                    code: scope.module_code,
                    label: scope.module_label || {},
                    scopes: [],
                });
            }
            modules[moduleIndex[scope.module_code]].scopes.push({
                code: scope.code,
                label: scope.label || {},
            });
        });
        return modules;
    },
};

const mutations = {
    updateScopes(state, scopes) {
        state.scopes = scopes || [];
        state.scopes_loaded = true;
    },
    updateScopesLoading(state, loading) {
        state.scopes_loading = loading;
    },
    updateScopesLoadingErrors(state, errors) {
        state.scopes_loading_errors = errors;
    },
    updateProfile(state, profile) {
        state.profile = profile;
    },
};

const actions = {
    async init({ commit }, params) {
        commit('updateProfile', params?.profile);
        commit('updateScopes', []);
    },

    async fetchScopes({ commit, state }) {
        commit('updateScopesLoading', true);
        commit('updateScopesLoadingErrors', null);
        try {
            const response = await axios.get('/api/scopes/', {
                params: state.profile ? { profile: state.profile } : {},
            });
            commit('updateScopes', response.data);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateScopesLoadingErrors', error.details);
            throw error;
        } finally {
            commit('updateScopesLoading', false);
        }
    },
};

export default () => ({
    namespaced: true,
    state: createState(),
    getters,
    mutations,
    actions,
});
